import React from 'react'
import ReactEcharts from 'echarts-for-react'
import ecStat from 'echarts-stat'
import * as echarts from 'echarts'
import { Row, Col, Form, Button, Select, Table } from 'antd'
import { reqPopulationPca, reqPopulationstructure } from '../../api'
import lycopersicum from '../../images/genomics/lycopersicum.jpg'
import cerasiforme from '../../images/genomics/cerasiforme.jpg'
import pimpinellifolium from '../../images/genomics/pimpinellifolium.jpg'


import './populations.css'

const { Option } = Select
echarts.registerTransform(ecStat.transform.clustering)

class Populations extends React.Component {
	/*
    state = {
        pca1_option: {},
        pca2_option: {},
        structure_option: {},
        showLoading: true
    }

    getPCAEchartOption = (data, pc1, pc2) => {
        let categories = ['Gossypium barbadense', 'Gossypium hirsutum', 'Gossypium darwinii', 'Gossypium ekmanianum', 'Gossypium mustelinum', 'Gossypium tomentosum']
        let color = ['#749F83', '#91C7AE', '#D48265', '#61A0A8', '#2F4554', '#C23531']
        const upper_pc1 = pc1.toUpperCase()
        const upper_pc2 = pc2.toUpperCase()

        let option = {
                title: {text: `PCA:${upper_pc1} ${upper_pc2}`},
                tooltip: {
                    position: 'top',
                    trigger: 'axis',
                    formatter: function(data)
                    {
                        let info = 'Sample: ' + data[0].data[2] + '<br />'
                        info += 'Group: ' + data[0].data[3] + '<br />'
                        
                        return info
                    }
                },
                toolbox: {
                    feature: {
                        dataZoom: {
                            yAxisIndex: false,
                            title: {
                                zoom: 'region zoom',
                                back: 'restore zoom'
                            }
                        },
                        saveAsImage: {
                            pixelRatio: 2,
                            title: 'Save as PNG'
                        }
                    },
                    right: 40
                },
                visualMap: {
                    top: 'top',
                    dimension: 3,
                    orient: 'horizontal',
                    left: 200,
                    categories: categories,
                    color: color
                },
                grid: {
                    left: 120
                },
                xAxis: {
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                },
                yAxis: {
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                },
                series: {
                    type: 'scatter',
                    data: data,
                    encode: { tooltip: [0, 1] },
                    symbolSize: 10,
                    itemStyle: {
                        borderColor: '#555'
                    },
                }
            }
        
        
        return option
    }

    getStructureEchartOption = (data, k) => {
        let color = [
            "#8DD3C7", "#FFFFB3", "#BEBADA", 
            "#FB8072", "#80B1D3", "#FDB462", 
            "#B3DE69", "#FCCDE5", "#D9D9D9", 
            "#BC80BD", "#CCEBC5", "#FFED6F", 
            "#E41A1C", "#377EB8", "#4DAF4A",
          ]

        let legend_data = []
        let series = []
        for (let i=0; i<k; i++) {
            let legend = 'K' + (i + 1)
            legend_data[i] = legend
            let series_data = data.map(v => {
                return Number(v[i+2])
            })
            series[i] = {
                name: legend,
                type: 'bar',
                barGap: "0.01%",
                stack: 'all',
                emphasis: {
                    focus: 'series'
                },
                data: series_data,
                color: color[i]
            }
        }

        let category_data = data.map(item => item[1])
        
        let option = {
            title: {text: 'Population Structure'},
            tooltip: {
                trigger: 'axis',
            },
            toolbox: {
                feature: {
                    restore: {show: true},
                    saveAsImage: {
                        pixelRatio: 2,
                        title: 'Save as PNG'
                    }
                },
                right: 40
            },
            legend: {
                data: legend_data
            },
            grid: {
                left: '3%',
                right: '4%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: category_data
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    max: 1
                }
            ],
            dataZoom: [
                {   
                    type: 'slider',
                    show: true,
                    start: 50,
                    end: 70,
                }
            ],
            series: series
        }

        return option
    }

    onFinish = async (values) => {
        const structure_result = await reqPopulationstructure(values.k)
        let structure_data = []
        if (structure_result.code === 0) {
            structure_data = structure_result.data
        }

        const structure_option = this.getStructureEchartOption(structure_data, values.k)

        this.setState({ 
            structure_option: structure_option
        })
    }
	*/

    async componentDidMount() {
	    /*
        // pca echart 1
        const pca1_reuslt = await reqPopulationPca('pc1', 'pc2')
        let pca1_data = []
        if (pca1_reuslt.code === 0) {
            pca1_data = pca1_reuslt.data
        }

        const pca1_option = this.getPCAEchartOption(pca1_data, 'pc1', 'pc2')

        // pca echart 2
        const pca2_reuslt = await reqPopulationPca('pc1', 'pc3')
        let pca2_data = []
        if (pca2_reuslt.code === 0) {
            pca2_data = pca2_reuslt.data
        }

        const pca2_option = this.getPCAEchartOption(pca2_data, 'pc1', 'pc3')

        // structure echart
        
        const structure_result = await reqPopulationstructure(8)
        let structure_data = []
        if (structure_result.code === 0) {
            structure_data = structure_result.data
        }

        const structure_option = this.getStructureEchartOption(structure_data, 8)
        
        this.setState({ 
            pca1_option: pca1_option,
            pca2_option: pca2_option, 
            structure_option: structure_option,
            showLoading: false
        })
	*/
    }

    render() {
        const table_columns = [
            {
                title: 'Profile',
                key: 'profile',
                dataIndex: 'profile'
            },
            {
                title: 'Name',
                key: 'name',
                dataIndex: 'name'
            },
            {
                title: 'Species',
                key: 'species',
                dataIndex: 'species'
            },
	    {
                title: 'Size',
                key: 'size',
                dataIndex: 'size'
            },
            {
                title: 'Description',
                key: 'description',
                dataIndex: 'description'
            },
        ]

        const table_data = [
            {
                key: 1,
                profile: <img src={lycopersicum} />,
                name: 'Tomato706',
		species: <span>S. lycopersicum;<br /> S. lycopersicum var. cerasiforme;<br /> S. pimpinellifolium</span>,
		size: 706,
		description: 'Previous resequencing projects (NCBI BioProjects PRJNA259308, PRJNA353161, PRJNA454805 and PRJEB5235) accumulated 7.8 Tb of Illumina short-read data for 706 tomato accessions with sequencing depth higher than six-fold. The panel inculding 374 S. lycopersicum (BIG) accessions, 255  cherry tomato (S. lycopersicum var. cerasiforme, CER) accessions, and 77 accessions from S. pimpinellifolium (PIM, considered to be the progenitor of cultivated tomatoes). '
            }
        ]

        return (
            <React.Fragment>
                <div>
                    <Table title={() => <h2>Population list</h2>} columns={table_columns} dataSource={table_data} pagination={false} />
                </div>
            </React.Fragment>
        )
    }
}

export default Populations
